export function buildResult (order) {
    return {
        tradename: order.TRADENAME,
    }
}
